import { restClient } from '@/Core'

import { DISK_ADMIN_API } from './diskAdminApi'

import type { DiskAdminOverview } from '../Contracts/DiskAdmin'

/** Огляд компанії: `GET /services/disk/admin/overview` — живі агрегати тенанта. */
export const LoadDiskAdminOverviewTask = async (): Promise<DiskAdminOverview> =>
    (await restClient.get(`${DISK_ADMIN_API}/overview`, {}, { forceRefresh: true })) as unknown as DiskAdminOverview
